import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyResponse, SurveyOption } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-multiple-choice-single-select-survey-step',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './multiple-choice-single-select-survey-step.component.html',
  styleUrls: ['./multiple-choice-single-select-survey-step.component.scss']
})
export class MultipleChoiceSingleSelectSurveyStepComponent extends BaseSurveyStepComponent {
  selectedOptionId: string | null = null;

  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    private translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.initialStepResponse && this.initialStepResponse.response?.[0]) {
      this.selectedOptionId = this.initialStepResponse.response[0]._id;
    }
  }

  onSelectOption(option: SurveyOption) {
    this.selectedOptionId = option._id;
  }

  override isValid(): boolean {
    if (!this.selectedOptionId) return false;
    const selectedOption = this.stepData?.options?.find((opt: SurveyOption) => opt._id === this.selectedOptionId);
    return !!selectedOption;
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    if (!this.selectedOptionId) return undefined;
    const selectedOption = this.stepData?.options?.find((opt: SurveyOption) => opt._id === this.selectedOptionId);
    if (!selectedOption) return undefined;
    return {
      stepId: this.stepData._id,
      showValueInReport: false,
      response: [
        {
          _id: selectedOption._id,
          values: [selectedOption.value]
        }
      ]
    };
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }
}
